/*global gtag*/
/*eslint no-undef: ["error", { "typeof": true }] */
export default {
    mounted() {
        const isActive = this.$store.getters['settings/cookieconsent']
        const isTracking = this.$store.getters['settings/tracking']
        const revision = this.$store.getters['settings/cookieconsent_revision']
        if (!isActive || !isTracking) return 
        
        const cc = window.CookieConsent
        cc.run({
            onFirstConsent: function(cookie) {
                console.log('onFirstConsent')
            },
            onConsent: function () {
                console.log('onConsent')
                if (cc.acceptedCategory('marketing')) {
                    if (typeof gtag !== 'undefined') {
                        gtag('consent', 'update', {
                            'ad_storage':'granted'
                        });
                    }
                }
            },
            onChange: function(cookie, changedCategories, changedPreferences) {
                console.log('onChange')
                if(changedCategories.includes('marketing')) {
                    if (cc.acceptedCategory('marketing')) {
                        if (typeof gtag !== 'undefined') {
                            gtag('consent', 'update', {
                                'ad_storage':'granted'
                            });
                        }
                    } else {
                        if (typeof gtag !== 'undefined') {
                            gtag('consent', 'update', {
                                'ad_storage':'denied'
                            });
                        }
                    }
                }
            },
            cookie: {
                name: 'cc_multiversity_cookie'
            },
            categories: {
                necessary: {
                    enabled: true,
                    readOnly: true
                },
                analytics: {
                    enabled: false,
                    readOnly: false,
                },
                marketing: {
                    enabled: false,
                    readOnly: false
                }
            },
            guiOptions: {
                consentModal: {
                    layout: 'box wide',
                    position: 'middle center',
                    flipButtons: true,
                    equalWeightButtons: false
                },
                preferencesModal: {
                    layout: 'box',
                    flipButtons: false,
                    equalWeightButtons: true
                }
            },
            language: {
                default: 'it',
                translations: {
                    it: {
                        consentModal: {
                            title: 'Usiamo i cookie',
                            description: 'Usiamo i cookie e altre tecniche di tracciamento per migliorare la tua esperienza di navigazione nel nostro sito, per mostrarti contenuti personalizzati e annunci mirati, per analizzare il traffico sul nostro sito e per capire da dove arrivano i nostri visitatori.',
                            acceptAllBtn: 'Accetta tutti',
                            acceptNecessaryBtn: '',
                            showPreferencesBtn: 'Personalizza',
                            closeIconLabel: false,
                            footer: '<a href="/privacy">Informativa Privacy</a>'
                        },
                        preferencesModal: {
                            title: 'Centro Preferenze Cookie',
                            acceptAllBtn: 'Accetta tutti',
                            acceptNecessaryBtn: 'Rifiuta tutti',
                            savePreferencesBtn: 'Accetta la selezione',
                            closeIconLabel: 'Chiudi',
                            sections: [
                                {
                                    title: 'Utilizzo dei Cookie',
                                    description: 'I cookie sono dei piccolissimi file di testo che vengono memorizzati nel tuo computer quando visiti un sito web. Noi usiamo i cookie per una varietà di scopi e per migliorare la tua esperienza online nel nostro sito web. Tu puoi cambiare le tue impostazioni e rifiutare che alcuni tipi di cookie vengano memorizzati sul tuo computer mentre stai navigando nel nostro sito web. Puoi anche rimuovere qualsiasi cookie già memorizzato nel tuo computer, ma ricorda che cancellare i cookie puÃ² impedirti di utilizzare alcune parti del nostro sito.'
                                },
                                {
                                    title: 'Cookie strettamente necessari',
                                    description: 'I cookie necessari contribuiscono a rendere fruibile il sito web abilitandone funzionalità di base quali la navigazione sulle pagine e l\'accesso alle aree protette del sito. Il sito web non è in grado di funzionare correttamente senza questi cookie.',
                                    linkedCategory: 'necessary'
                                },
                                {
                                    title: 'Cookie di tracciamento e misurazione',
                                    description: 'I cookie di tracciamento e misurazione aiutano i proprietari del sito web a capire come i visitatori interagiscono con i siti raccogliendo e trasmettendo informazioni in forma anonima.',
                                    linkedCategory: 'analytics'
                                },
                                {
                                    title: 'Cookie di marketing',
                                    description: 'I cookie di marketing vengono utilizzati per tracciare i visitatori sui siti web. La finalità è quella di presentare annunci pubblicitari che siano rilevanti e coinvolgenti per il singolo utente e quindi di maggior valore per editori e inserzionisti di terze parti.',
                                    linkedCategory: 'marketing'
                                },
                                {
                                    title: 'Maggiori informazioni',
                                    description: 'Per maggiori informazioni in relazione alla nostra cookie policy e le relative scelte, consulta <a href="/cookie-policy">questa pagina</a>.'
                                }
                            ]
                        }
                    }
                }
            }
        });
    }
}